<div mat-dialog-content>
    <span class="logo-pelecard"></span>

    <div align="center" style="font-size: 18px;">       
        <div>{{ 'PAYMENT.BIT-NOT-NOT-SET-MSG' | translate  }}</div>
    </div>
</div>
  
  
<div mat-dialog-actions align="center">    
    <button mat-raised-button color="primary" class="w-100" cdkFocusInitial (click)="onClose($event)">{{ 'COMMON.OK' | translate }}</button>
</div> 
